module.exports = __webpack_public_path__ + "img/lzds-logo.821ee31f.png";